import axiosInstance from '../axiosInstance';

export const getTransactions = async (params = {}) => {
  const response = await axiosInstance.get('/finance/payments/transactions', {
    params: { ...params, _t: Date.now() },
  });
  if (!response.data.success) {
    throw new Error(response.data.message || 'Failed to fetch transactions');
  }
  return response.data;
};

const PAYMENT_METHOD_DISPLAY = {
  bank_transfer: 'Bank Transfer', sepa: 'SEPA', swift: 'SWIFT',
  cash: 'Cash', visa: 'Visa', mastercard: 'Mastercard',
  amex: 'Amex', stripe: 'Stripe', paypal: 'PayPal', direct_debit: 'Direct Debit',
};

const CLIENT_TYPE_DISPLAY = {
  client_payment: 'Client Payment',
  supplier_payment: 'Supplier Payment',
  client_refund: 'Client Refund',
  supplier_refund: 'Supplier Refund',
};

export const normalizeTransaction = (p) => ({
  id: p.id,
  transactionRef: p.payment_reference || `TXN-${p.id}`,
  direction: p.direction === 'incoming' ? 'Incoming' : 'Outgoing',
  type: CLIENT_TYPE_DISPLAY[p.client] || p.payment_type || '—',
  bookingRef: p.booking_reference || '—',
  entityName: p.customer_name || p.supplier_name || '—',
  entityEmail: p.customer_email || p.supplier_email || '',
  entityType: p.customer_name ? 'Customer' : 'Supplier',
  amount: parseFloat(p.amount || 0),
  currency: p.currency || 'EUR',
  date: p.payment_date,
  paymentMethod: PAYMENT_METHOD_DISPLAY[p.payment_method] || p.payment_method || '—',
  account: p.account_name || p.account || '—',
  reference: p.transaction_id || p.payment_reference || '—',
  airlinePnr: p.airline_pnr || '',
  supplierReferenceNo: p.supplier_reference_no || '',
  transactionId: p.transaction_id || '',
  notes: p.notes || '',
  status: p.status,
});
